// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__2oSHy","modalOuter":"style_modalOuter__1wQkY"};